import { render } from "./AlbertaHeader.vue?vue&type=template&id=6421ab9a&scoped=true"
import script from "./AlbertaHeader.vue?vue&type=script&lang=ts"
export * from "./AlbertaHeader.vue?vue&type=script&lang=ts"

import "./AlbertaHeader.vue?vue&type=style&index=0&id=6421ab9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6421ab9a"

export default script